import { FC } from 'react';
import { CheckCircle2 } from 'lucide-react';
import { useTranslation } from '@hooks/useTranslation';

export interface SetupDoneMobileWebProps {
  appStoreUrl: string;
  playStoreUrl: string;
}

/**
 * Sprint 47, story-232. Completion state for viewports <= 768: the password is set, no web
 * session is started (the web app blocks small viewports), and the user is pointed at the app.
 */
export const SetupDoneMobileWeb: FC<SetupDoneMobileWebProps> = ({
  appStoreUrl,
  playStoreUrl,
}) => {
  const tSetup = useTranslation('setup');
  const linkClass =
    'flex items-center justify-center gap-2 bg-black text-white rounded-lg px-4 py-3 hover:bg-gray-800 transition-colors';
  return (
    <div className="flex flex-col gap-4" data-testid="setup-done-mobile">
      <div className="flex items-start gap-2">
        <CheckCircle2
          aria-hidden="true"
          className="mt-1 h-5 w-5 shrink-0 text-green-600"
        />
        <h1
          tabIndex={-1}
          className="text-xl font-bold text-gray-900 dark:text-white">
          {tSetup.doneTitle}
        </h1>
      </div>
      <p className="text-gray-600 dark:text-gray-300">{tSetup.doneBody}</p>
      <div className="flex flex-col gap-3">
        <a
          href={appStoreUrl}
          target="_blank"
          rel="noopener noreferrer"
          className={linkClass}>
          <span className="text-sm font-semibold">{tSetup.appStore}</span>
        </a>
        <a
          href={playStoreUrl}
          target="_blank"
          rel="noopener noreferrer"
          className={linkClass}>
          <span className="text-sm font-semibold">{tSetup.playStore}</span>
        </a>
      </div>
    </div>
  );
};

export default SetupDoneMobileWeb;
